import {
  DullText,
  Instructions,
  ProductStatusChip,
  UnavailableProductCardRoot,
} from '@/components/products/refill/UnavailableProductRefillCard';
import { Box, Typography } from '@montugroup/design-system';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import type { UnavailableProductRefillCardProps } from './types';

export const UnavailableNewScriptCard = (props: UnavailableProductRefillCardProps) => {
  const { productName, issue, shouldShowStatusChip = true } = props;
  const severityClass = issue.isHighSeverity ? 'severity-high' : '';

  return (
    <UnavailableProductCardRoot aria-label={`Card for Unavailable Product: ${productName}`}>
      {shouldShowStatusChip && (
        <Box>
          <ProductStatusChip className={severityClass} variant="outlined" label={issue.title} />
        </Box>
      )}
      <DullText variant="subtitle2" sx={{ fontWeight: 600 }} aria-hidden>
        {productName}
      </DullText>
      <Instructions className={severityClass}>
        {!issue.isHighSeverity && <InfoOutlined />}
        {issue.requiresInfoOutline && <InfoOutlined />}
        <Box sx={{ display: 'block' }}>
          {issue.info.map((info, index) => {
            return (
              <Typography
                key={`refill-card-info-${index}`}
                sx={{
                  '&:not(:first-of-type)': {
                    mt: 4,
                  },
                }}
              >
                {info}
              </Typography>
            );
          })}
        </Box>
      </Instructions>
    </UnavailableProductCardRoot>
  );
};
